import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import PageHeader from '../component/pageheader'
import {API_IMAGES, API_URL, ServerUrl, Token, config, userCode} from '../../component/include'
import axios from 'axios'
import {  getClassField, getResultHead} from '../component/globalFunction'
import { userToken } from '../component/authentication'
import { useSelector } from 'react-redux'
import { Alerts } from '../component/notify'

const Documents =()=> {
const [notice, setNotice] = useState({
    isLoading : false, 
    isDataFetching: false,
})
  
const schoolClass  = useSelector(state => state.rootReducer.schoolClass); 
const [allDocument, setAllDocument]= useState([]) 
const [profile, setProfile]=useState({
  classArm:'',
});


       
const getLink =(code, link, classArm)=>{

  const linkHandler ={
    defe: API_IMAGES+'/students/documents/'+link,
    de2fe:API_IMAGES+'/students/documents/'+link,
    de3fe:API_IMAGES+'/students/documents/'+link,
    de34e:API_IMAGES+'/students/documents/'+link,
    de54e:API_IMAGES+'/students/documents/'+link,
    de56e:'#!',
    de576e:ServerUrl+'/printout/admission_letter/'+classArm,
    gdtd:'#!',
    gdt9d:ServerUrl+'/printout/student_profile.php?studentCode='+userCode+'&token='+userToken,
    gdt10d:'#!'
  }
  return linkHandler[code];
  }

  
  const handleFetchStudent =async()=>{
    setNotice({...notice,  isLoading: true})
    var sql ="Select studentName, code, admissionNumber, startFromClass, startFromSection  from tbl_students where code ='"+userCode+"'"; 

    const fd = new FormData(); 
  fd.append("sql", sql);
  
    let url = API_URL+'/exam/result/fetch_raw'
  await axios.post(url, fd, config).then(result=>{
    
    let startFromClass = result.data.data[0].startFromClass
var classType = String(getClassField(startFromClass, schoolClass, 'arms'))
const classArm = getResultHead(classType)!=='Secondary'?'Primary':'Secondary'

let urli = API_URL + '/fetch/data/tbl_school_documents'
axios.get(urli, config).then(response=>{

  const option  = response.data.data
    const list  = []
    for (var i = 0; i< option.length;  i++) {
      list.push(
          {  
              code:option[i].code,
              link:getLink(option[i].code, option[i].file_url, classArm),
              file_url:option[i].file_url,
             type:option[i].document_type,
              order:option[i].order_by,
          });
          }

          setAllDocument(list)

          setProfile({...profile,  classArm:classArm});
        })
  })
  .catch((error)=>{
    Alerts('Error!', 'danger', error.message)
  }).finally(()=>{
    setNotice({...notice,  isLoading: false})
  })
}


              const background = ['bg-simple-c-blue', 'bg-simple-c-green', 'bg-simple-c-pink', 'bg-simple-c-yellow', 'bg-c-blue', 'bg-c-green', 'bg-c-pink', 'bg-c-yellow', 'bg-simple-c-blue', 'bg-simple-c-green', 'bg-simple-c-pink', 'bg-simple-c-yellow', 'bg-c-blue', 'bg-c-green', 'bg-c-pink', 'bg-c-yellow'];
             


    useEffect(()=>{
      handleFetchStudent()
  },[]);


        return (  
            
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title='Student Documents'>
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-dashboard"></i> </a>
                            </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">




              <div className="row">
        <div className="col-12">
          <div className="card">
		   <div className="card-header">
            <strong> DOCUMENT LIST</strong>
				</div>
             <div className="card-body">
           

<div className="row">
{allDocument.map((item, index)=><div className="col-xl-6 col-md-12" key={index}>
        <form  method='POST' action={item.link} target='_blank' >

        <input type='hidden' name='studentCode' value ={userCode} />

        <input type='hidden' name='jwtToken' value ={Token} />
        <input type='hidden' name='classArm' value ={profile.classArm} />


              <div className= {`card social-card ${background[index]}`}>
                  <div className="card-block">
                      <div className="row align-items-center">
                          <div className="col-auto">
                              <i className={`feather icon-file-text f-34 social-icon text-c-blue`}></i>
                          </div>
                          <div className="col">
                              <h4 className="m-b-0">{item.type}</h4>    
                      <button type='submit' className={`btn btn-inverse btn-sm btn-round mt-1 `}><i className="feather icon-arrow-down"></i> Preview</button>
                          </div>
                      </div>
                  </div>
                  {/* <a href={item.link} className="download-icon" ><i className="feather icon-arrow-down"></i></a> */}
              </div>
              </form>
          </div>)}


          </div>



             </div>
          </div>
        </div></div>






   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(Documents) 